import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination, StatusStorage } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class StatusStorageService extends BaseApiService<StatusStorage> {
  get cacheKey(): StorageKey {
    return StorageKey.statusStorageServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/statusStorages`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }
  list(params: {[params: string]: string}): Promise<Pagination<StatusStorage>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return StatusStorage.unparse(obj);
  }

  protected parse(obj) {
    return StatusStorage.parse(obj);
  }

}
